<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">{{'Choose a day' | translate}}</h5>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="date-picker-row">

            <mat-form-field class="date-field">
                <mat-label></mat-label>
                <input matInput [matDatepicker]="picker" [value]="selectedDate" (dateChange)="onDateChange($event)" />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <div class="nav-group">
                <button mat-stroked-button class="nav-btn" type="button" (click)="goToPreviousDay()">
                    <mat-icon>chevron_left</mat-icon>
                    {{'Previous' | translate}}
                </button>

                <button mat-stroked-button class="nav-btn" type="button" (click)="goToNextDay()"
                    [disabled]="isNextDayDisabled">
                    {{'Next' | translate}}
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>

        </div>
    </mat-card-content>
</mat-card>